module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wod-page"
  }, [_c('div', {
    staticClass: "foo wod-page__header"
  }, [_c('H1', [_vm._v(_vm._s(_vm.locale.t('label_wod')))]), _vm._v(" "), _c('div', {
    staticClass: "new-button btn-my wod-page__action",
    on: {
      "click": function($event) {
        return _vm.allWodTrainings()
      }
    }
  }, [_c('i', {
    staticClass: "ti-list"
  }), _vm._v(" " + _vm._s(_vm.locale.t("label_all_wod_trainings")))]), _vm._v(" "), (_vm.role === 'ROLE_SUPER_ADMIN') ? _c('div', {
    staticClass: "new-button wod-page__action",
    on: {
      "click": function($event) {
        return _vm.seeWodAsUser()
      }
    }
  }, [_c('i', {
    staticClass: "ti-list"
  }), _vm._v(" " + _vm._s(_vm.locale.t("label_see_wod_as_user")) + "\n      ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "wod-navigation wod-page__nav"
  }, [_c('div', {
    staticClass: "wod-arrow",
    on: {
      "click": function($event) {
        return _vm.changeWeek(-1)
      }
    }
  }, [_vm._v("◀")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.currentWeek))]), _vm._v(" "), _c('div', {
    staticClass: "wod-arrow",
    on: {
      "click": function($event) {
        return _vm.changeWeek(1)
      }
    }
  }, [_vm._v("▶")])]), _vm._v(" "), _c('div', {
    staticClass: "wod-container wod-page__grid"
  }, _vm._l(([0, 1, 2, 3, 4, 5, 6]), function(item) {
    return _c('div', {
      staticClass: "wod-item"
    }, [_c('div', [_vm._v(_vm._s(_vm.week[item].date))]), _vm._v(" "), _c('div', {
      staticClass: "new-button wod-font-copy",
      on: {
        "click": function($event) {
          return _vm.copyTrainingForDates(_vm.week[item])
        }
      }
    }, [_c('i', {
      staticClass: "ti-save"
    }), _vm._v(" " + _vm._s(_vm.locale.t('label_copy_rd')))]), _vm._v(" "), _c('button', {
      staticClass: "wod-plus-button",
      on: {
        "click": function($event) {
          return _vm.showDefinitionAdd(_vm.week[item])
        }
      }
    }, [_vm._v("+")]), _vm._v(" "), _vm._l((_vm.week[item].details), function(detailsItem) {
      return _c('div', {
        staticClass: "wod-content"
      }, [_c('div', {
        staticClass: "wod-font-title"
      }, [_vm._v(_vm._s(_vm.getName(detailsItem)) + "\n            "), _c('span', {
        staticClass: "new-button"
      }, [_c('i', {
        staticClass: "ti-pencil",
        on: {
          "click": function($event) {
            return _vm.editDefinitionData(detailsItem)
          }
        }
      })]), _vm._v(" "), _c('span', {
        staticClass: "new-button",
        on: {
          "click": function($event) {
            return _vm.deleteTrainingOfTheDay(detailsItem)
          }
        }
      }, [_c('i', {
        staticClass: "ti-trash icon-danger"
      })])]), _vm._v(" "), (detailsItem.trainingType != null) ? _c('div', {
        staticClass: "wod-font-md"
      }, [_c('u', [_vm._v(_vm._s(detailsItem.trainingType))])]) : _vm._e(), _vm._v(" "), (detailsItem.category != null) ? _c('div', {
        staticClass: "wod-font-md"
      }, [_c('u', [_vm._v(_vm._s(detailsItem.category))])]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "wod-font-md"
      }, [_vm._v(_vm._s(_vm.getShortDesc(detailsItem)))]), _vm._v(" "), _vm._l((_vm.getLongDesc(detailsItem).split('<hr>')), function(innerText, index) {
        return _c('div', {
          staticClass: "w-full"
        }, [_c('p', {
          staticClass: "wod-font-sm"
        }, [_vm._v(_vm._s(innerText))]), _vm._v(" "), (index < _vm.getLongDesc(detailsItem).split('<hr>').length - 1) ? _c('p', {
          staticClass: "wod-separator-interrupted"
        }) : _vm._e()])
      }), _vm._v(" "), (detailsItem.coachNotes != null) ? _c('div', [_vm._v("---------------")]) : _vm._e(), _vm._v(" "), (detailsItem.coachNotes != null) ? _c('div', {
        staticClass: "wod-font-xs"
      }, [_vm._v(_vm._s(_vm.locale.t('label_wod_coach_notes')) + ": " + _vm._s(detailsItem.coachNotes))]) : _vm._e(), _vm._v(" "), (_vm.week[item].details.length > 1) ? _c('p', {
        staticClass: "wod-separator"
      }) : _vm._e()], 2)
    })], 2)
  }), 0), _vm._v(" "), _c('add-training-of-the-day-wod', {
    attrs: {
      "show": _vm.showAddDefinition,
      "date": _vm.addDefinitionDate,
      "type": 'WOD',
      "data": _vm.definitionDataToEdit
    }
  }), _vm._v(" "), _c('choose-training-definition-modal', {
    attrs: {
      "show": _vm.showChooseDefinition,
      "date": _vm.chooseDefinitionDate,
      "type": 'WOD'
    }
  }), _vm._v(" "), _c('copy-training-for-dates', {
    attrs: {
      "show": _vm.copyTrainingForDate,
      "item": _vm.copyTrainingForDateItem
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0e38e5c4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Wod/Wod.vue
// module id = 709
// module chunks = 0